import { Card, createStyles, WithStyles } from '@material-ui/core';
import { inject } from 'mobx-react';
import React from 'react';
import { IObservation } from 'src/Definitions';
import { IStores } from 'src/Stores';

const styles = createStyles({
    observationCard: {},
    observationType: {},
});

interface IObservationCardProps extends WithStyles<typeof styles> {
    observation: IObservation;
    getObservationIcon?: (observation: IObservation) => React.ReactNode;
}

class ObservationCard extends React.Component<IObservationCardProps> {
    public render() {
        const observation = this.props.observation;
        const observationIcon = this.props.getObservationIcon!(observation);
        return (
            <Card className={this.props.classes.observationCard}>
                <p>
                    <b>{observation.observerName}:</b> {observation.observationDescription}
                </p>
                <p className={this.props.classes.observationType}>
                    {observationIcon} {this.props.observation.observationType.observationTypeName}
                </p>
            </Card>
        );
    }
}

const InjectedObservationCard = inject<
    IStores,
    IObservationCardProps,
    Partial<IObservationCardProps>,
    any
>((stores: IStores) => ({
    getObservationIcon: stores.observations.getObservationIcon,
}))(ObservationCard);

export default InjectedObservationCard;



// WEBPACK FOOTER //
// ./src/affinityClusters/ObservationCard.tsx